import React from 'react';

import Avatar from "@mui/joy/Avatar";
import Chip from "@mui/joy/Chip";

// components
import {retrieveImage} from "../../utils/misc";


class SubscriberSmallProfile extends React.Component {
    constructor(props) {
        super(props);
        let subscriber = this.props.subscriber
        if (this.props.componentObj){
            if (this.props.componentObjKey){
                subscriber = this.props.componentObj[this.props.componentObjKey]
            }
        }
        this.state = {
            image: null,
            subscriber: subscriber,
        };
    }

    async componentDidMount() {
        await this.retrieveImage();
    }

    async retrieveImage(){
        let image = await retrieveImage(
            'Subscriber',
            'image',
            this.state.subscriber.id
        )
        this.setState(
            {
                image: image
            }
        );
    }

    render() {
        return(
            <Chip
                key={'SubscriberSmallProfile'+this.state.subscriber.id}
                startDecorator={
                    <Avatar
                        key={'SubscriberSmallProfileAvatar'+this.state.subscriber.id}
                        src={`data:image/jpeg;base64,${this.state.image}`}
                        size="sm"
                    />
                }
            >
                {this.state.subscriber.user.first_name[0] + '. ' + this.state.subscriber.user.last_name}
            </Chip>
        )
    }
}

export default SubscriberSmallProfile;